import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { buildPage } from '../Page';

export default function PortalModal({ modalProps, headerProps, footerProps, footerChildren, bodyProps, children, button, closeButton, header, ...props }) {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const toggle = e => {
		e?.preventDefault?.();
		setOpen(!open);
	};
	return <>
		<Button {...props} onClick={toggle}>{button ?? t('Modal.Open')}</Button>
		<Modal {...modalProps} isOpen={open} toggle={toggle} children={children}>
			<ModalHeader {...headerProps} toggle={toggle}>{header}</ModalHeader>
			<ModalBody {...bodyProps} children={children} />
			<ModalFooter {...footerProps}>
				{footerChildren && footerChildren.map(buildPage)}
				<Button onClick={toggle}>{closeButton ?? t('Modal.Close')}</Button>
			</ModalFooter>
		</Modal>
	</>;
}
